<template>
  <DragDialog v-model:visible="visible" :title="dialogTitle" :defaultPosition="position" width="500" >
    <template v-if="visible">
      <img :src="formData" alt="" srcset="" style="width: 100%;">
    </template>
  </DragDialog>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import DragDialog from '@/components/dialogs/DragDialog.vue'

const visible = ref(false)
const dialogTitle = ref()
const formData = ref()
const position = ref({ top: 130, left: 30 })

const open = (data) => {
  const padding = 30;
  visible.value = true
  dialogTitle.value = '图片详情'
  formData.value = data
  position.value.left = window.innerWidth/2-250
}

const close = () => {
  visible.value = false
}

defineExpose({ open, close })
</script>

<style lang="scss" scoped>

</style>